module.exports = __webpack_public_path__ + "static/img/com-group.5e3cbde5.png";